import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const promotionCodeReducer = (state = {isSubmitting: false, validatedPromotionCode: false, errorStatus: false, errorMessage: false, codeInformation: {}}, action) => {

    switch (action.type) {

        case ActionTypes.PROMOTIONCODE_VALIDATE_REQUEST:
        case ActionTypes.PROMOTIONCODE_DATA_REQUEST:

            return Object.assign({}, state, {isSubmitting: true, codeInformation: {}})

        case ActionTypes.PROMOTIONCODE_VALIDATE_SUCCESS:

            return Object.assign({}, state, {isSubmitting: false, validatedPromotionCode: true, errorStatus: false, errorMessage: false})

        case ActionTypes.PROMOTIONCODE_VALIDATE_FAILURE:

            return Object.assign({}, state, {isSubmitting: false, validatedPromotionCode: false, errorStatus: action.status, errorMessage: action.error})

        case ActionTypes.PROMOTIONCODE_DATA_SUCCESS:

            if (action.response.result && action.response.result.articles) {
                action.response.result.articles = action.response.result.articles.map((val) => {
                    return val.articleNumber
                })
            }

            return Object.assign(
                {},
                state,
                {
                    isSubmitting: false,
                    codeInformation: Object.assign(
                        action.response.result, {
                            code: action.payload.promotionCode
                        }
                    )
                }
            )

        case ActionTypes.PROMOTIONCODE_INIT:

            return Object.assign({}, state, {isSubmitting: false, validatedPromotionCode: true, errorStatus: false})

        case ActionTypes.PROMOTIONCODE_RESET:

            return Object.assign({}, state, {isSubmitting: false, validatedPromotionCode: false, errorStatus: false, codeInformation: {}})

        default:
            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/PromotionCode.js
 **/